import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import muiThemeable from 'material-ui/styles/muiThemeable';

const CustomFlatButton = muiThemeable()(
  ({
    label,
    muiTheme: { CustomFlatButtonStyle },
    primary,
    secondary,
    disabled,
    white,
    ...props
  }) => (
    <FlatButton
      label={label}
      primary={primary}
      secondary={secondary}
      disabled={disabled}
      {...props}
      style={{
        ...CustomFlatButtonStyle,
        ...props.style,
        ...white ? { borderColor: '#ffffff', color: '#ffffff' } : {},
      }}
    />
  ),
);

export default CustomFlatButton;



// WEBPACK FOOTER //
// ./src/components/Button/CustomFlatButton.js